import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { MessageService } from 'src/app/services/message.service';
import { BusApiService } from 'src/app/services/api/bus-api.service';
import { ChangePopcornModalComponent } from '../change-popcorn-modal/change-popcorn-modal.component';
import { Router } from '@angular/router';
import { ChangeJiegehaoModalComponent } from '../change-jiegehao-modal/change-jiegehao-modal.component';
import { RefundWalletModalComponent } from '../refund-wallet-modal/refund-wallet-modal.component';
import { FreezeModalComponent } from '../freeze-modal/freeze-modal.component';

@Component({
  selector: 'app-choose-compensate-netflix-modal',
  templateUrl: './choose-compensate-netflix-modal.component.html',
  styleUrls: ['./choose-compensate-netflix-modal.component.scss'],
})
export class ChooseCompensateNetflixModalComponent implements OnInit {
  index = 1;

  constructor(
    protected dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ChooseCompensateNetflixModalComponent>,
    private api: BusApiService,
    private message: MessageService,
    private router: Router
  ) {}

  ngOnInit(): void {}

  changeIndex(i: number) {
    this.index = i;
  }

  infos: any;
  loading = false;

  async waitRepairTime() {
    try {
      this.loading = true;
      const r = await this.api.waitRepairTime(
        this.data.id,
        this.data.bus_id,
        this.data.bus.bus_account_id
      );
      if (r.status === 0) {
        this.message.open('提交成功');
        this.dialogRef.close();
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => {
            this.router.navigate(['/user/profile/seats']);
          });
      } else {
        this.message.warn('提交失败');
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  changePopcorn() {
    this.dialogRef.close();
    this.dialog.open(ChangePopcornModalComponent, {
      width: '600px',
      data: Object.assign({}, this.data),
      panelClass: 'app-dialog',
    });
  }

  changeJiegehao() {
    this.dialogRef.close();
    this.dialog.open(ChangeJiegehaoModalComponent, {
      width: '600px',
      data: Object.assign({}, this.data),
      panelClass: 'app-dialog',
    });
  }

  refund() {
    this.dialogRef.close();
    this.dialog.open(RefundWalletModalComponent, {
      width: '570px',
      data: Object.assign({}, this.data),
      panelClass: 'app-dialog',
    });
  }

  async freeze() {
    this.dialogRef.close();
    this.dialog.open(FreezeModalComponent, {
      width: '570px',
      data: Object.assign({}, this.data),
      panelClass: 'app-dialog',
    });
  }
}
